<div class="app-tabs-container">
  <ul class="list-unstyled app-tabs">
    <li class="app-tabs__tab">
      <a class="app-tabs__button app-tabs__button--profile" routerLink="/profile" routerLinkActive="active" href="#">
        <span class="app-tabs__inner-container">
          <svg class="icon">
            <use xlink:href="assets/symbol/svg/sprite.css.svg#icon_nav_profile"></use>
          </svg>
          <span class="label" i18n="@@profile">
            Profile
          </span>
        </span>
      </a>
    </li>
    <li class="app-tabs__tab">
      <a class="app-tabs__button app-tabs__button--menu" routerLink="/recipes" routerLinkActive="active" href="#">
        <span class="app-tabs__inner-container">
          <svg class="icon">
            <use xlink:href="assets/symbol/svg/sprite.css.svg#icon_nav_menu"></use>
          </svg>
          <span class="label" i18n="@@yourMenu">
            Your menu
          </span>
        </span>
      </a>
    </li>
    <li class="app-tabs__tab">
      <a class="app-tabs__button app-tabs__button--shopping" routerLink="/shoplist" routerLinkActive="active" href="#">
        <span class="app-tabs__inner-container">
          <svg class="icon">
            <use xlink:href="assets/symbol/svg/sprite.css.svg#icon_nav_shopping"></use>
          </svg>
          <span class="label" i18n="@@shoppingList">
            Shopping list
          </span>
        </span>
      </a>
    </li>
  </ul>
</div>
